import { useState } from "nuxt/app";

export const useAuthUser = () => {
  const user = useState<User | null>("auth:user", () => null);
  const authRepository = useAuthRepository();

  const identifyPostHogUser = (u: User | null) => {
    const posthog = usePostHog();
    if (!posthog || !u) return;
    posthog.identify(String(u.id), {
      email: u.email,
      name: `${u.names} ${u.paternalSurname}`
    });
  };

  const login = async (identificator: string, password: string) => {
    const analytics = useAnalytics();
    analytics.capture("login_started");
    const res = await authRepository.login({ identificator, password });
    if (res.error) {
      analytics.capture("login_failed", {
        error_code: res.error.appCode || "UNKNOWN"
      });
      return res;
    }

    const refreshResponse = await refreshUser();
    if (refreshResponse.error) {
      analytics.capture("login_failed", {
        error_code: refreshResponse.error.appCode || "SESSION_NOT_AVAILABLE"
      });
      return refreshResponse;
    }

    analytics.capture("user_logged_in");
    return res;
  };

  const refreshUser = async () => {
    const res = await authRepository.me();
    if (res.error) {
      user.value = null;
      const posthog = usePostHog();
      posthog?.reset();
      return res;
    }
    user.value = res.data ?? null;
    identifyPostHogUser(user.value);
    return res;
  };

  const logout = async () => {
    const posthog = usePostHog();
    posthog?.reset();
    await authRepository.logout();
    if (process.client) {
      window.location.reload();
    }
  };

  return { user, refreshUser, logout, login };
};
